module.exports = __webpack_public_path__ + "static/media/ever_pano_01-min.321cfc92.JPG";